import {
  FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE,
  FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS,
  FETCH_MENU_INFO_SUCCESS,
  FETCH_SPEECH_BUBBLE_FAILURE,
  FETCH_SPEECH_BUBBLE_SUCCESS,
  HIDE_CHATBOT,
  SEND_CHATBOT_INJECT_MESSAGE,
  SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE,
  SHOW_CHATBOT,
  UPDATE_CLOSED_SPEECH_BUBBLE,
} from '../actions/chatbotAction';

const defaultState = {
  menuInfo: {},
  shouldShowChatbot: false,
  speechBubbleList: [],
  closedSpeechBubbleCustState: [],
  closedSpeechBubbleLocalState: [],
  injectedMessage: null,
};

export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    case FETCH_MENU_INFO_SUCCESS:
      nextState.menuInfo = action.menuInfo;
      return nextState;
    case SHOW_CHATBOT:
      nextState.shouldShowChatbot = true;
      return nextState;
    case HIDE_CHATBOT:
      nextState.shouldShowChatbot = false;
      return nextState;

    case FETCH_SPEECH_BUBBLE_SUCCESS:
      nextState.speechBubbleList = action.payload;
      return nextState;
    case FETCH_SPEECH_BUBBLE_FAILURE:
      nextState.speechBubbleList = [];
      return nextState;

    case FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS:
      const { payload } = action;
      if (payload) {
        nextState.closedSpeechBubbleCustState = action.payload;
      }
      return nextState;
    case FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE:
      return nextState;
    case UPDATE_CLOSED_SPEECH_BUBBLE:
      const { sbObj } = action.payload;
      if (nextState.closedSpeechBubbleCustState) {
        nextState.closedSpeechBubbleCustState.closedSpeechBubble =
          nextState.closedSpeechBubbleCustState.closedSpeechBubble || [];
        if (
          !nextState.closedSpeechBubbleCustState.closedSpeechBubble.find(
            (sb) => sb && sb.sbId === sbObj.sbId,
          )
        ) {
          nextState.closedSpeechBubbleCustState.closedSpeechBubble.push(sbObj);
        }
      }
      return nextState;
    case SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE:
      nextState.closedSpeechBubbleLocalState = action.payload || [];
      return nextState;
    case SEND_CHATBOT_INJECT_MESSAGE:
      nextState.injectedMessage = action.payload;
      return nextState;
    default:
      return nextState;
  }
};
